<template>
  <div class="wrapper">
    <!-- 头部 -->
    <div class="header-wrapper">
      <!-- 切换按钮 -->
      <switch-tab :arr="arrtab" :selectIndex="selectIndex" @changeTab="changeTab"></switch-tab>
      <!-- 标题 -->
      <div class="header">{{arrtab[selectIndex]}}</div>
    </div>
    <!-- 统计图列表 -->
    <div class="statistics">
      <statistics-activity v-show="selectIndex==0"></statistics-activity>
      <!-- 事件统计 -->
      <statistics-event :show="selectIndex==1" v-show="selectIndex==1"></statistics-event>
    </div>
  </div>
</template>

<script>
import switchTab from "./components/switchTab";
import statisticsActivity from "./components/statistics_activity";
import statisticsEvent from "./components/statistics_event";

export default {
  components: {
    switchTab,
    statisticsActivity,
    statisticsEvent
  },
  created() {},
  mounted() {},
  data() {
    return {
      arrtab: ["活动统计", "事件统计"],
      selectIndex: 0, // tab 索引
    };
  },
  methods: {
    changeTab(index) {
      this.selectIndex = index;
    }
  }
};
</script>
<style lang="less" scoped>
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  color: #666;
  font-size: 25px;
}
/* 统计图表 */
.statistics {
  padding: 0 20px;
}
</style>

